import React, { memo } from "react";
import { getClassNameFactory } from "@dcl/ui";
import CheckCircle from "@dcl/icons/esm/ui/check-circle-08";
import SquareDelete10 from "@dcl/icons/esm/nucleo/small/user-interface/square-delete-10";
export var TableCheckbox = function TableCheckbox(_ref) {
  var id = _ref.id,
      checked = _ref.checked,
      disabled = _ref.disabled,
      ariaLabel = _ref.ariaLabel,
      indeterminate = _ref.indeterminate,
      onChange = _ref.onChange;
  var getClassName = getClassNameFactory(TableCheckbox.displayName);
  var labelId = "".concat(id, "-label");
  var ariaChecked = indeterminate ? "mixed" : checked;

  var renderTableCheckbox = function renderTableCheckbox() {
    return /*#__PURE__*/React.createElement("div", {
      "aria-hidden": true,
      className: getClassName({
        descendantName: "checkbox",
        modifiers: indeterminate && "indeterminate"
      })
    }, indeterminate ? /*#__PURE__*/React.createElement(SquareDelete10, {
      width: 18
    }) : checked && /*#__PURE__*/React.createElement(CheckCircle, {
      width: 18
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    "aria-checked": ariaChecked,
    "aria-labelledby": labelId,
    type: "checkbox",
    checked: checked,
    disabled: disabled,
    className: getClassName({
      descendantName: "input",
      utilities: "hiddenVisually"
    }),
    onChange: onChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    id: labelId
  }, renderTableCheckbox(), /*#__PURE__*/React.createElement("p", {
    className: getClassName({
      utilities: "hiddenVisually"
    })
  }, ariaLabel)));
};
TableCheckbox.displayName = "TableCheckbox";
export default /*#__PURE__*/memo(TableCheckbox);